import React from 'react';
import { Table } from 'lucide-react';
import DataTable from './DataTable';

const SmartVisualization = ({ data, columns, title, description }) => {
  // CSV Export function
  const exportToCSV = () => {
    if (!data || data.length === 0) return;
    
    // Create CSV content
    const csvContent = [
      // Header row
      columns.join(','),
      // Data rows
      ...data.map(row => 
        columns.map(col => {
          const value = row[col];
          // Escape commas and quotes in CSV
          if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
            return `"${value.replace(/"/g, '""')}"`;
          }
          return value || '';
        }).join(',')
      )
    ].join('\n');
    
    // Create and download file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${title || 'data'}_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (!data || data.length === 0) {
    return (
      <div className="text-center py-8 text-slate-400">
        <Table className="h-12 w-12 mx-auto mb-4 text-slate-600" />
        <p>No data available to display</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">

      {/* Description */}
      {description && (
        <p className="text-sm text-slate-300 bg-slate-800/30 p-3 rounded-lg border border-slate-700/30">
          {description}
        </p>
      )}

      {/* Data Table */}
      <DataTable data={data} columns={columns} />
    </div>
  );
};

export default SmartVisualization;